import script from "./RequestsRevisionView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsRevisionView.vue?vue&type=script&setup=true&lang=js"

import "./RequestsRevisionView.vue?vue&type=style&index=0&id=4b85cc1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b85cc1e"]])

export default __exports__